import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'phoneFormat'
})
export class PhoneFormatPipe implements PipeTransform {
  transform(phoneNumber: string): string {
    // Remove any non-numeric characters from the phone number
    const cleaned = phoneNumber.replace(/\D/g, '');

    // Check if the number starts with a country code
    if (cleaned.startsWith('0')) {
      return '+33' + cleaned.substring(1); // Assuming France country code (33)
    } else {
      return '+33' + cleaned; // Assuming France country code (33)
    }
  }
}
